export default __webpack_public_path__ + "static/media/thr.2cb639bc.png";